import React from "react";
import { useLoading } from "../../Utils/LoadingContext";
import "./Loader.css";

const Loader = () => {
  const { isLoading } = useLoading();

  if (!isLoading) return null;

  return (
    <div className="loader-overlay" role="status" aria-label="Loading">
      <div className="loader-orbit">
        {[...Array(8)].map((_, i) => (
          <span key={i} className="orbit-dot" style={{ "--i": i }} />
        ))}
      </div>
    </div>
  );
};

export default Loader;
